const API_BASE = `${process.env.PUBLIC_URL || ''}/backend/api`;

const request = async (endpoint, options = {}) => {
    const response = await fetch(`${API_BASE}/${endpoint}`, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(options.headers || {})
        },
        ...options
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
        throw new Error(data.message || 'Request failed');
    }

    return data;
};

export const adminLogin = (username, password) => request('login.php', {
    method: 'POST',
    body: JSON.stringify({ username, password })
});

export const adminLogout = () => request('logout.php', {
    method: 'POST',
    body: JSON.stringify({})
});

export const adminMe = () => request('me.php');

export const listContent = (moduleName) => request(`content-list.php?module=${encodeURIComponent(moduleName)}`);

export const createContent = (payload) => request('content-create.php', {
    method: 'POST',
    body: JSON.stringify(payload)
});

export const updateContent = (payload) => request('content-update.php', {
    method: 'POST',
    body: JSON.stringify(payload)
});

export const deleteContent = (id) => request('content-delete.php', {
    method: 'POST',
    body: JSON.stringify({ id })
});

export const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE}/upload.php`, {
        method: 'POST',
        credentials: 'include',
        body: formData
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok || !data.success) {
        throw new Error(data.message || 'Upload failed');
    }
    return data;
};
